// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Yjpc0WlbWrzv0yQf7RK2,.pkad9fuoRK_zEAXFeAah{width:100%;margin-bottom:30px}.tKXkCDuJyZn5QlahvLLq,.x74hxQSo8TY0Sk09cGCc{display:flex;color:#f6f6f6;font-size:18px;font-weight:bold;margin-bottom:30px;padding:15px 0;text-align:center;width:100%}.tKXkCDuJyZn5QlahvLLq i,.x74hxQSo8TY0Sk09cGCc i{margin-right:10px}.ECR314H3NSO_NGKXb7N5{width:100%}.ECR314H3NSO_NGKXb7N5 .tKXkCDuJyZn5QlahvLLq i,.ECR314H3NSO_NGKXb7N5 .x74hxQSo8TY0Sk09cGCc i{margin-left:10px}@media screen and (max-width: 767px){.tKXkCDuJyZn5QlahvLLq,.x74hxQSo8TY0Sk09cGCc{font-size:14px;margin-bottom:20px;padding:10px 0}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scheduleDetailContainer": `Yjpc0WlbWrzv0yQf7RK2`,
	"scheduleDetailContainer": `pkad9fuoRK_zEAXFeAah`,
	"scheduleDetailBackButton": `tKXkCDuJyZn5QlahvLLq`,
	"scheduleDetailBackButton": `x74hxQSo8TY0Sk09cGCc`,
	"rtl": `ECR314H3NSO_NGKXb7N5`
};
module.exports = ___CSS_LOADER_EXPORT___;
